import Vue from 'vue'
import contractReceiverApi from '@/api/contractReceiver.api'

const state = {
  receivers: []
}


const getters = {
  contractReceivers: (state) => {
    return state.receivers
  },

  contractReceiversById: (state) => (id) => {
    return state.receivers.find(receiver => receiver.contactId === id) || null
  }
}


const actions = {
  async loadContractReceivers ({ commit, rootState }) {
    const response = await contractReceiverApi.getContractReceivers(rootState.tenant.current)
    commit('SET_RECEIVERS', response.data)
  },

  async loadContractReceiverById ({ commit, rootState }, id) {
    const response = await contractReceiverApi.getContractReceiver(rootState.tenant.current, id)
    commit('SET_RECEIVER', response.data)
    return response.data
  },

  async createContractReceiver ({ commit, rootState }, receiverIds) {
    const response = await contractReceiverApi.createContractReceiver(rootState.tenant.current, receiverIds)
    commit('SET_RECEIVERS', response.data)
  },

  async deleteContractReceiver ({ commit, rootState }, receiverId) {
    await contractReceiverApi.deleteContractReceiver(rootState.tenant.current, receiverId)
    const response = await contractReceiverApi.getContractReceivers(rootState.tenant.current)
    commit('SET_RECEIVERS', response.data)
  }
}


const mutations = {
  SET_RECEIVERS (state, receivers) {
    state.receivers = [...receivers]
  },

  SET_RECEIVER (state, receiver) {
    Vue.set(state.receivers, receiver.id, receiver)
  }
}


export default {
  state,
  getters,
  actions,
  mutations
}
